/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './list.scss';
import './modifier/condensed.scss';
import './modifier/icon-before.scss';
import './modifier/numbered.scss';
